import { Env } from '@environments/environment.types';
import { SentryEnvironment } from '@shared/sentry/sentry.types';

export const environment: Env = {
  production: true,
  prodMode: true,
  apiMarketPath: '/market-api',
  apiLivingPath: '/living-api',
  apiRemoveBgPath: '/remove-bg-api',
  apiVersion: {
    v0: '/v0',
    v1: '/v1',
    v2: '/v2',
  },

  sentry: {
    dsn: 'https://8711c3b9f0164a63ac74ae13c188cff5@sentry.ugol.click/8',
    enabled: true,
    environment: SentryEnvironment.STAGE,
  },
};
